angular.module('rjmNg.directives').directive "magentoOnboardingWizard", [
  () ->
    restrict: "E"
    templateUrl: "directive.magentoOnboardingWizard.html"
    replace: false
    controllerAs: "view"
    bindToController: true
    scope: {}
    controller: [
      "$location"
      "app"
      ($location, 
       app) ->

        view = @

        channelsSteps = [
          activePath: "magento/connect/googleAdwords"
          text: "Connect Google Ads"
        ,
          activePath: "magento/connect/mysql"
          text: "Connect your database"
          subText: "optional"
        ,
          activePath: "magento/connect/googleAnalytics"
          text: "Connect Google Analytics"
          subText: "optional"
        ,
          activePath: "magento/connect/success"
          text: "Success"
        ]

        defaultSteps = [
          activePath: "magento/preferences"
          text: "Set your preferences"
        ,
          activePath: "magento/database"
          text: "Connect your database"
        ]

        _isActiveStep = (activePath) ->
          $location.path().indexOf(activePath) isnt -1
        
        _setActiveStep = () ->
          view.steps.map((step) ->
            step.isActive = _isActiveStep(step.activePath)
          )

        view.$onInit = () ->
          if(app.isMagentoChannels())
            view.steps = channelsSteps;
          else
            view.steps = defaultSteps;
          _setActiveStep()

        view
    ]
]
